<div 
  [style.width]="(isMinorThanTablet | async).matches ? mobileWidth : width" 
  [style.height]="height" 
  [style.border-radius]="radius" 
  [style.margin]="margin"
  class="skeleton">
</div>
